export default "__VITE_ASSET__r0fVfwTlitNxoPQeP7StEg__"